import React, {useEffect, useState} from "react";
import styled from "styled-components";
import Button from "../common/Button";
import TreeView from "../explorer/TreeView";
import {useFolderStore} from "../../app/store/FolderStore";
import {observer} from "mobx-react";
import {ModalBody} from "./Modal";
import {toast} from "react-toastify";

const MoveItemModal = ({
                           entryType,
                           modalDepth,
                           handleCloseModal,
                           modalMutate
                       }) => {
    const folderStore = useFolderStore();
    useEffect(() => {
        folderStore.setCurrentFolderInModal(modalDepth, entryType, folderStore.folders[entryType])
        return () => {
            folderStore.clearInModal(modalDepth, entryType);
        }
    }, []);

    let [forceRadio, setForceRadio] = useState(false);
    const moreForce = (e) => {
        setForceRadio(e.target.value);
    }

    return (
        <ModalBody>
            <EditFolderMoveModal>
                <h2>경로 지정</h2>
                <div className={"list-wrap"}>
                    <div className={"contents"}>
                        <h3>즐겨찾기</h3>
                        <div className={"list"}>
                            {
                                folderStore.getBookmarks(entryType).length > 0 ?
                                    <TreeView
                                        treeType={'Bookmark'}
                                        entryType={entryType}
                                        modalMutateFoldersAndBookmarks={modalMutate}
                                        isActionModal={true}
                                        modalDepth={modalDepth}
                                    />
                                    : <div className={"no-entry-folder"}>
                                        즐겨찾는 폴더가 없습니다.
                                    </div>
                            }

                        </div>
                    </div>
                    <div className={"contents"}>
                        <h3>
                            {
                                {
                                    CLIP: '클립보드',
                                    COMMON: '공통보드',
                                    TEMPLATE: '템플릿'
                                }[entryType]
                            }
                        </h3>
                        <div className={"list"}>
                            {
                                folderStore.folders[entryType]?.children &&
                                folderStore.folders[entryType]?.children.length > 0 ?
                                    <TreeView
                                        treeType={'Folder'}
                                        entryType={entryType}
                                        modalMutateFoldersAndBookmarks={modalMutate}
                                        isActionModal={true}
                                        modalDepth={modalDepth}
                                    />
                                    : <div className={"no-entry-folder"}>
                                        폴더가 없습니다.
                                    </div>
                            }
                        </div>
                    </div>
                </div>

                <div className={"select-move"}>
                    <span className={"notice"}>동일한 폴더/파일명이 존재하는 경우</span>
                    <div className={"radio-move-wrap"}>
                        <div className={"input-radio-wrap"}>
                            <input
                                type={"radio"}
                                id={"skip"}
                                name={"move-radio"}
                                defaultChecked={"checked"}
                                value={"false"}
                                onChange={(e) => {
                                    moreForce(e)
                                }}/>
                            <label htmlFor={"skip"}>건너뛰기</label>
                        </div>
                        <div className={"input-radio-wrap"}>
                            <input
                                type={"radio"}
                                id={"paste"}
                                name={"move-radio"}
                                value={"true"}
                                onChange={(e) => {
                                    moreForce(e)
                                }}/>
                            <label htmlFor={"paste"}>덮어쓰기 </label>
                        </div>
                    </div>
                </div>

                <div className="btn-wrap">
                    <Button
                        type={"outline"}
                        size={"l"}
                        text={"취소"}
                        className={"white"}
                        onClickFunc={() => {
                            handleCloseModal(modalDepth);
                        }}
                    />
                    <Button
                        type={"fill"}
                        size={"l"}
                        text={"이동"}
                        onClickFunc={async () => {
                            try {
                                await folderStore.moveList(entryType, modalDepth, Boolean(forceRadio));
                                folderStore.clearSaveItems();
                                await modalMutate();
                                folderStore.setCurrentAfterActionInModal(entryType, modalDepth);
                                toast(`완료되었습니다.`);
                            } catch (e) {
                                folderStore.clearSaveItems();
                                console.log(`err => ${e.message}`);
                            } finally {
                                handleCloseModal(modalDepth);
                            }
                        }}
                    />
                </div>
            </EditFolderMoveModal>
        </ModalBody>

    );
};

const ModalHeader = styled.div`
    background: var(--Gray-1000_-262626, #262626);
    height: 48px;
    padding: 0 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    h1 {
        color: var(--White_-FFFFFF, #fff);
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: 24px; /* 150% */
        letter-spacing: -0.16px;
    }

    svg {
        cursor: pointer;
    }
`;
const EditFolderMoveModal = styled.div`
    background-color: #fff;
    padding: 32px;
    height: 100%;

    > h2 {
        margin-bottom: 16px;
        color: #262626;
        font-size: 14px;
        font-weight: 500;
        line-height: 20px;
        letter-spacing: -0.14px;
    }

    & .list-wrap {
        border-radius: 4px;
        background: #FAFAFA;
        max-height: 321px; //값이 홀수여야 글자 깨짐 현상이 없음(?)
        overflow-y: scroll;

        & .contents {
            display: block;
            padding: 0 0 16px;

            .list .no-entry-folder {
                text-align: center;
                padding: 16px 0;
                color: #B0B0B0;
                font-size: 12px;
                font-weight: 400;
                letter-spacing: -0.12px;
            }

            & h3 {
                color: #3B3B3B;
                font-size: 13px;
                font-weight: 500;
                line-height: 18px;
                letter-spacing: -0.13px;
                padding: 20px 16px 16px;
            }

            & .star-icon {
                display: none;
            }
        }

        & .contents + .contents {
            border-top: 1px solid #EEE;
        }
    }

    div.select-move {
        margin: 32px auto;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .notice {
            font-size: 13px;
            color: #262626;
        }

        .radio-move-wrap {
            display: flex;
            align-items: center;

            .input-radio-wrap {
                position: relative;

                > input {
                    position: absolute;
                    left: -999999px;
                    width: 0;
                    height: 0;

                    &[type="radio"]:checked + label:after {
                        display: block;
                    }
                }

                > label {
                    display: flex;
                    align-items: center;
                    cursor: pointer;
                    position: relative;
                    padding-left: 20px;
                    font-size: 13px;
                    color: #262626;
                    line-height: 1;

                    &::after {
                        content: '';
                        width: 10px;
                        height: 10px;
                        background: #C86733;
                        position: absolute;
                        top: 1px;
                        left: 3px;
                        border-radius: 100%;
                        display: none;
                    }

                    &::before {
                        content: '';
                        position: absolute;
                        left: 0;
                        top: -2px;
                        width: 16px;
                        height: 16px;
                        border: 1px solid #C86733;
                        border-radius: 100%;
                        background: #fff;
                    }
                }
            }

            .input-radio-wrap + .input-radio-wrap {
                margin-left: 16px;
            }
        }
    }

    div.btn-wrap {
        display: flex;
        align-items: center;
        gap: 0 10px;
        margin-top: 20px;

        button {
            background: #262626;
            color: #fff;
            border: none;
            width: 100%;
            font-weight: 500;
            line-height: 20px; /* 142.857% */
            letter-spacing: -0.14px;
            font-size: 14px;

            &:hover {
                border: none;
            }
        }

        button.white {
            border: 1px solid #C8C8C8;
            color: #262626;
            background-color: transparent;
        }
    }

    div.input-wrap {
        margin-bottom: 24px;

        label {
            display: block;
            width: 100%;
            margin-bottom: 8px;
            color: var(--Gray-1000_-262626, #262626);
            font-size: 13px;
            font-style: normal;
            font-weight: 400;
            line-height: 18px;
            letter-spacing: -0.13px;
        }

        input {
            height: 32px;
            padding: 0 12px;
            font-size: 12px;
        }
    }
`;

const ModalContainer = styled.article`
    position: relative;
    box-sizing: content-box;
    min-width: 320px;
    max-width: ${(props) => (props.$width ? `${props.$width}px` : "auto")};
    width: 500px;
    max-height: 90vh;
    margin: 0 auto;
    overflow: hidden;
    box-shadow: 0 0 10px rgba(98, 120, 233, 0.1);
    background-color: #ffffff;
    border-radius: 8px;
    z-index: 100;
`;

const Dimmer = styled.div`
    position: fixed;
    z-index: 100;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    padding: 20px;
    background-color: rgba(0, 0, 0, 0.4);
    display: flex;
    justify-content: center;
    align-items: center;
`;

const Modal = styled.div`
    display: none;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 99;

    &.active {
        display: flex;
        align-items: center;
        justify-content: center;
    }
`

const TableDisplay = styled.div`

    z-index: 100;
`;

export default observer(MoveItemModal);
